// Password managers read the PQ's name, phone and money boxes as a login or an
// identity form and put their own button inside them: LastPass's "•••" sat on
// top of the Company Match figure in QA (Aditi, 2026-10-15) and in every name
// box on Kory's audit screenshot. Nothing in the PQ is a login, so every field
// is marked with the opt-outs LastPass, 1Password and Bitwarden each read.
// Done once here, for fields rendered now and later, rather than on each of
// the app's fifty-odd inputs, so a new field cannot forget it.
const OPT_OUT = {
  'data-lpignore': 'true', // LastPass
  'data-1p-ignore': 'true', // 1Password
  'data-bwignore': 'true', // Bitwarden
  'data-form-type': 'other', // Dashlane
};

const FIELDS = 'input:not([type="hidden"]), textarea, select';

function mark(el) {
  for (const [k, v] of Object.entries(OPT_OUT)) {
    if (el.getAttribute(k) !== v) el.setAttribute(k, v);
  }
}

function markWithin(node) {
  if (!(node instanceof Element)) return;
  if (node.matches(FIELDS)) mark(node);
  node.querySelectorAll(FIELDS).forEach(mark);
}

export function keepPasswordManagersOut(root = document.body) {
  if (typeof MutationObserver === 'undefined' || !root) return () => {};
  markWithin(root);
  const observer = new MutationObserver(records => {
    for (const r of records) r.addedNodes.forEach(markWithin);
  });
  observer.observe(root, { childList: true, subtree: true });
  return () => observer.disconnect();
}
